export default __webpack_public_path__ + "static/media/identificacao.b1006260.svg";